/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferRequestOffersResponse } from '../../models/offer-request-offers-response';

export interface GetOffersByOfferRequestId$Params {
  offerRequestId: string;
}

export function getOffersByOfferRequestId(http: HttpClient, rootUrl: string, params: GetOffersByOfferRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferRequestOffersResponse>> {
  const rb = new RequestBuilder(rootUrl, getOffersByOfferRequestId.PATH, 'get');
  if (params) {
    rb.path('offerRequestId', params.offerRequestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferRequestOffersResponse>;
    })
  );
}

getOffersByOfferRequestId.PATH = '/offers/requests/{offerRequestId}/offers';
